import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AssessmentIcon from '@mui/icons-material/Assessment';
import * as theme from '../../theme';

export default function FileUploadLink({ children, ...props }) {
  return (
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
      <div className={'cardLink'} style={{ display: 'flex', flex: 3, width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} onClick={() => props.onClick(props.id)}>
        <div style={{ ...theme.Container.flexRowFixed, padding: 8 }}>
          <AssessmentIcon sx={{ flex: '0 0 auto' }} />
          <div style={{ flex: 1, fontSize: 14, fontWeight: 500, paddingLeft: 4 }}>
            {props.label}
            <br />
            <span style={{ fontWeight: 'normal', fontSize: '0.85em', color: theme.Colors.GrayMedium }}>{props.content}</span>
          </div>
          
        </div>
      </div>
      {props.focusScan && 
        <div style={{ flex: 1 }}>
          {children}
        </div>
      }
      {props.showDelete && (
        <div style={{ display: 'flex', flex: 0.5, justifyContent: 'right', width: '100%'}} onClick={() => props.onDelete(props.id)}>
          <IconButton aria-label="delete" color="error">
            <DeleteIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </div>
      )}
    </div>
  );
}